module.exports = __webpack_public_path__ + "static/media/adengo.26224ee3.jpg";